module.exports = __webpack_public_path__ + "34fcc068d4b54b88101e522257edc3c5.pdf";